import { twMerge } from "@krea/shared/design-system/tailwind-utils";

import MenuLink, { IMenuLink } from "./MenuLink";

interface IMenuProps {
  className?: string;
  list: IMenuLink[];
  forMobile?: boolean;
  onCloseMenu?: () => void;
}

const Menu = ({ className, list, forMobile, onCloseMenu }: IMenuProps) => {
  return (
    <ul
      className={twMerge(
        "tw-flex tw-flex-col xl:tw-flex-row tw-items-center tw-list-none tw-visible",
        className,
      )}
    >
      {list.map((item, index) => (
        <li key={index} className="tw-mx-5 xl:tw-py-3">
          <MenuLink
            title={item.title}
            href={item.href}
            forMobile={forMobile}
            onCloseMenu={onCloseMenu}
            disabled={item.disabled}
          />
        </li>
      ))}
    </ul>
  );
};

export default Menu;
